import React from 'react';

import { TablePagination, Grid } from '@material-ui/core';
import TableSkeletonLoader from 'components/AlertScreens/TableSkeletonLoader';
import { showErrorMessage, showNoData } from 'screens/performanceReview/components/common';
import styled, { css } from 'styled-components';
import { FlexContainer, StyledGrid, StyledTypography, StyledPaper } from 'styles/common';

import { getColorFromKey } from 'constants/helper';
import theme from 'constants/theme';

export const SectionHeader = ({
  headerList,
  secondaryHeaderList,
  denseSecondaryHeader = false,
  icon = null,
  title = null,
}) => (
  <>
    {icon || title ? (
      <HeaderContainer container alignItems="flex-start" normal direction="row">
        {icon && <IconContainer color="textSecondary">{icon}</IconContainer>}
        {title && (
          <StyledTypography leftGutter={1.5} variant="h5" color={theme.palette.text.heading}>
            {title}
          </StyledTypography>
        )}
      </HeaderContainer>
    ) : null}
    <HeaderContainer container alignItems="center" normal>
      <Grid container justify="space-between" alignItems="center">
        {headerList.map(({ id, space, comp }) => (
          <Grid key={id} item sm={space}>
            {comp()}
          </Grid>
        ))}
      </Grid>
    </HeaderContainer>
    {secondaryHeaderList && (
      <HeaderContainer container alignItems="center" dense={denseSecondaryHeader}>
        <StyledGrid container justify="space-between" alignItems="center">
          {secondaryHeaderList.map(({ id, space, comp }) => (
            <Grid key={id} item sm={space}>
              {comp()}
            </Grid>
          ))}
        </StyledGrid>
      </HeaderContainer>
    )}
  </>
);

const HeaderContainer = styled(FlexContainer)`
  ${(props) =>
    props.normal &&
    css`
      padding: 1.5rem 1.5rem 1.25rem;
    `}
  ${(props) =>
    props.dense &&
    css`
      padding: 0.5rem 1.5rem 0.5rem 1.5rem;
    `}
  ${(props) =>
    props.alignItems &&
    css`
      align-items: ${props.alignItems};
    `}
  border-bottom: 1px solid ${theme.palette.borders.lighterGrey};
  letter-spacing: 0.275px;
  ${(props) => css`
    flex-direction: ${props.direction ? props.direction : 'column'};
  `}
`;

const IconContainer = styled.div`
  display: flex;
  color: ${(props) => getColorFromKey(props.color)};

  svg {
    height: 1.5rem;
    fill: ${(props) => getColorFromKey(props.color)};
  }
`;

const ChildWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  padding: ${(props) => props.padding};
  justify-content: center;
  cursor: ${(props) => (props.clickable ? 'pointer' : 'inherit')};
  &:hover {
    background: ${theme.palette.background.blue.light.v2};
  }
`;

const Divider = styled.div`
  border-bottom: 1px solid ${theme.palette.borders.lighterGrey};
  // margin: 0 1.5rem;
`;

const MeshGenericTable = ({
  title,
  success,
  noDataMessage,
  error,
  loading,
  titleIcon: TitleIcon = null,
  paginationData = null,
  listData = [],
  headerList = [],
  secondaryHeaderList = [],
  dataRowPadding = '1rem 1.5rem',
  wrapperPaperProps = {
    bottomGutter: 4,
    variant: 'elevation',
  },
  clickableRows = true,
}) => (
  <StyledFullWidthPaper {...wrapperPaperProps}>
    <SectionHeader
      headerList={headerList}
      secondaryHeaderList={secondaryHeaderList}
      denseSecondaryHeader
      title={title}
      icon={TitleIcon && <TitleIcon />}
    />

    {loading ? (
      <TableSkeletonLoader />
    ) : error ? (
      showErrorMessage({ errorText: error })
    ) : success && listData.length === 0 ? (
      showNoData({ infoText: noDataMessage })
    ) : (
      listData.map(({ comp, id }, index) => (
        <>
          <ChildWrapper clickable={clickableRows} padding={dataRowPadding} key={id}>
            {comp}
          </ChildWrapper>
          {index !== listData.length - 1 && <Divider />}
        </>
      ))
    )}
    {paginationData && (
      <StyledTablePagination
        component="div"
        count={paginationData.count || 0}
        rowsPerPage={paginationData.rowsPerPage || 0}
        rowsPerPageOptions={[]}
        page={paginationData.currentPage || 0}
        onChangePage={(e, newPage) => paginationData.setCurrentPage(newPage)}
        labelRowsPerPage={null}
      />
    )}
  </StyledFullWidthPaper>
);

const StyledTablePagination = styled(TablePagination)`
  padding: 0.5rem 1.5rem !important;
`;

const StyledFullWidthPaper = styled(StyledPaper)`
  width: 100%;
`;

export default MeshGenericTable;
